import { Component, OnDestroy, inject, effect } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsoService } from '@devinforius/i-sso';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnDestroy {
  private readonly router = inject(Router);
  private readonly activeRoute = inject(ActivatedRoute);
  private readonly ssoService = inject(SsoService);

  private readonly connectedEffect = effect(() => {
    if (this.ssoService.isConnected() || this.ssoService.hasValidAccessToken()) {
      this.router.navigateByUrl('/private/ic/courriers');
    }
  });

  constructor() {
    this.activeRoute.queryParams.subscribe({
      next: (params) => {
        if (params?.infosPoint) {
          localStorage.setItem('iCourrier_point_id_send', params.infosPoint);
        }
      },
    });
  }

  login(): void {
    if (this.ssoService.hasValidAccessToken()) {
      this.ssoService.setConnection(true);
    } else {
      this.ssoService.login();
    }
  }

  ngOnDestroy(): void {
    this.connectedEffect.destroy();
  }
}